import React, { memo, useEffect, useState } from "react";

// material core
import Link from "@material-ui/core/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Avatar } from "@mui/material";

import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import { userSelector } from "selectors/auth.selector";
import { appheaderSelector, breadcrumbSelector } from "selectors/app.selector";
import { changeNavBarView } from "actions/app.action";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useHistory } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
// styles
import useStyles from "./styles";
import { Typography } from "@material-ui/core";
import clsx from "clsx";
import httpRequest from "services/httpRequest";
import authService from "services/authService";

type Crumbs = {
  label: string | undefined;
  path: string | undefined;
};

type IProps = {
  handleToogleDrawer?: () => void;
  isDrawer?: boolean;
  subheader?: Crumbs[] | undefined;
  header?: string;
};

function TopBar(props: IProps) {
  const [imagesrc, setImageSrc] = useState("");
  const history = useHistory();
  const classes = useStyles();
  const currentuserinfo: any = useSelector(userSelector);
  const { header, isNavEnlarged } = useSelector(appheaderSelector);
  const breadcrumbsData = useSelector(breadcrumbSelector);

  const fetchUserProfileImage = async () => {
    const res: any = await authService.fetchUserProfileImage({
      user_id: currentuserinfo?.currentuserinfo?.id || currentuserinfo?.id,
      phone_number:
        currentuserinfo?.currentuserinfo?.phone_number ||
        currentuserinfo?.phone_number,
    });

    if (!res.error) {
      setImageSrc(res?.imageUrl || "");
    }
  };
  useEffect(() => {
    if (currentuserinfo?.id) {
      fetchUserProfileImage();
    }
  }, [currentuserinfo]);

  if (!currentuserinfo.isuserlogin) {
    return <></>;
  }

  if (!header) {
    return <></>;
  }

  const formatName = (name: string, maxLen = 25) => {
    if (!name) return "";
    return name.length > maxLen ? name.substring(0, maxLen) + "..." : name;
  };

  const formatEmail = (email: string, maxLen = 25) => {
    if (!email) return "";
    return email.length > maxLen ? email.substring(0, maxLen) + "..." : email;
  };

  const initials = currentuserinfo?.currentuserinfo
    ? `${currentuserinfo?.currentuserinfo?.first_name?.substring(
        0,
        1,
      )}${currentuserinfo?.currentuserinfo?.last_name?.substring(0, 1).toUpperCase()}`
    : "US";

  return (
    <div style={{ backgroundColor: "white" }}>
      <div
        className={
          isNavEnlarged
            ? classes.container
            : clsx([classes.container, classes.closedcontainer])
        }
      >
        <Stack spacing={2}>
          <Typography
            variant="h4"
            style={{
              marginBottom: 0,
              fontFamily: "lexend",
              color: "#16151C",
              fontWeight: 600,
            }}
          >
            {header}
          </Typography>

          <Breadcrumbs
            separator={
              <NavigateNextIcon fontSize="small" className={classes.icon} />
            }
            aria-label="breadcrumb"
            style={{
              marginTop: 0,
              marginBottom: 20,
            }}
            classes={{
              separator: classes.separator,
            }}
          >
            {breadcrumbsData &&
              breadcrumbsData.map((crumb) =>
                crumb.triggerFunc ? (
                  <div
                    onClick={() => {
                      crumb.triggerFunc();
                    }}
                  >
                    {crumb.label}
                  </div>
                ) : (
                  <Link
                    style={{
                      fontFamily: "lexend",
                      fontWeight: 300,
                      color: "#16151C",
                      marginBottom: 20,
                      cursor: "pointer",
                    }}
                    underline="hover"
                    key="1"
                    onClick={
                      crumb.path ? () => history.push(crumb.path) : undefined
                    }
                  >
                    {crumb.label}
                  </Link>
                ),
              )}
          </Breadcrumbs>
        </Stack>

        <PopupState variant="popover" popupId="demo-popup-menu">
          {(popupState) => (
            <React.Fragment>
              <Button
                startIcon={
                  <Avatar
                    src={imagesrc || undefined}
                    sx={{
                      // bgcolor: imagesrc ? "transparent" : "#2BFFFF",
                      bgcolor: imagesrc ? "transparent" : "transparent",
                      color: "#000",
                      fontWeight: 700,
                      width: 40,
                      height: 40,
                      fontSize: 16,
                      border: "1px solid #A2A1A8 !important",
                      borderColor: "rgba(162, 161, 168, 0.2) !important",
                    }}
                  >
                    {!imagesrc && initials}
                  </Avatar>

                  // imagesrc ? (
                  //   <img
                  //     src={imagesrc || ""}
                  //     width={40}
                  //     height={40}
                  //     style={{
                  //       borderRadius: 8,
                  //     }}
                  //   />
                  // ) : (
                  //   <></>
                  // )
                }
                endIcon={<KeyboardArrowDownIcon />}
                variant="contained"
                {...bindTrigger(popupState)}
                className={classes.btnmenu}
              >
                <div style={{ textAlign: "left" }}>
                  <p
                    style={{
                      fontFamily: "Lexend",
                      textTransform: "capitalize",
                      fontSize: 13,
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    {formatName(currentuserinfo?.currentuserinfo?.first_name)}
                  </p>

                  <p
                    style={{
                      opacity: 0.5,
                      fontFamily: "Lexend",
                      fontWeight: 300,
                      textTransform: "capitalize",
                      color: "#16151C",
                      fontSize: 10,
                      padding: 0,
                      margin: 0,
                      marginTop: "-5px",
                    }}
                  >
                    {formatEmail(currentuserinfo?.currentuserinfo?.email)}
                  </p>
                  <p
                    style={{
                      opacity: 0.5,
                      fontFamily: "Lexend",
                      fontWeight: 300,
                      textTransform: "capitalize",
                      color: "#16151C",
                      fontSize: 10,
                      padding: 0,
                      margin: 0,
                      marginTop: "-5px",
                    }}
                  >
                    {currentuserinfo?.currentuserinfo?.designation?.name}
                  </p>
                </div>
              </Button>

              <Menu
                {...bindMenu(popupState)}
                classes={{ root: classes.menuroot, list: classes.menuroot }}
              >
                <MenuItem
                  onClick={() => {
                    popupState.close();
                    localStorage.clear();
                    window.location.reload();
                  }}
                >
                  Logout
                </MenuItem>
              </Menu>
            </React.Fragment>
          )}
        </PopupState>
      </div>
    </div>
  );
}

export default memo(TopBar);
